/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Entra_Step5Inputs */



/**
* | output |
* | --- |
* | "Enter the Secret Token (Bearer Token from above)" |
*
* @param {Scim_Setup_Entra_Step5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_entra_step5 = /** @type {((inputs?: Scim_Setup_Entra_Step5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Entra_Step5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie das Geheime Token ein (Bearer-Token von oben)")
	return /** @type {LocalizedString} */ ("Enter the Secret Token (Bearer Token from above)")
});